import React, { useEffect, useState } from "react";
import { NoteEditorField, renderTextField } from "../formcomponents";
import { reduxForm, Field, FieldArray } from "redux-form";

import { Grid, Divider, Label, Button, Header } from "semantic-ui-react";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import FileArrList from "./FieldArray/FileArrList";
import EmployeeArrList from "./FieldArray/EmployeeArrList";
import PartnerArrList from "./FieldArray/PartnerArrList";
import Swal from "sweetalert2";

import { useParams, useNavigate } from "react-router-dom";
const UpdateCompanyForm = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { urlId, id } = useParams();
  const [companyData, setcompanyData] = useState({});
  const [formLoading, setformLoading] = useState(false);
  useEffect(() => {
    // console.log("indexVal", indexVal);
    // initializeData(companyDetailList);
    if (urlId !== "null" && id !== "null") {
      setformLoading(true);
      getCompanyDetails();
    }
  }, []);

  useEffect(() => {}, []);

  const [fileArrayList, setfileArrayList] = useState([]);
  const getCompanyDetails = async (data) => {
    await axios
      .post(BaseUrl + "getCompanyDetails", { companyId: urlId })
      .then((res) => {
        console.log("Company Detail", res.data);
        setcompanyData(res.data);
        initializeData(res.data);

        console.log("submitObject", `${JSON.stringify(res.data, null, 2)}`);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [fileArrImageList, setfileArrImageList] = useState([]);

  const initializeData = (data) => {
    props.initialize({
      //aisbiab
      ...data,
      companyId: data.companyId,
      userId: data.userId,
      companyName: data.companyName,
      status: data.status,
      activities: data.activities,
      typeOfCompany: data.typeOfCompany,
      companyContact: data.companyContact,
      ownerOrPartner: data.ownerOrPartner,
      companyContact: data.companyContact,
      establismentCardNo: data.establismentCardNo,
      establismentCardExp: data.establismentCardExp,
      licenseNumber: data.licenseNumber,
      expiryDate: data.expiryDate,

      eMailId: data.eMailId,
      filesList: data.filesList,
      employeeList: data.employeeList,
      partnerList: data.partnerList,
    });
    const values = [...fileArrayList];
    if (data.filesList != "") {
      // for (let i = 0; i < data.filesList.length; i++) {
      //   values.push({ fileStorageId: data.filesList[i].fileStorageId });
      // }

      console.log("data.filesList", data.filesList);

      setfileArrImageList(data.filesList);
    }

    if (data.employeeList != "") {
      for (let i = 0; i < data.employeeList.length; i++) {
        values.push({ fileStorageId: data.employeeList[i].employeeFileId });
      }
      for (let i = 0; i < data.employeeList.length; i++) {
        values.push({ fileStorageId: data.employeeList[i].employeeFileId2 });
      }
      for (let i = 0; i < data.employeeList.length; i++) {
        values.push({ fileStorageId: data.employeeList[i].employeeFileId3 });
      }
      for (let i = 0; i < data.employeeList.length; i++) {
        values.push({ fileStorageId: data.employeeList[i].employeeFileId4 });
      }
      for (let i = 0; i < data.employeeList.length; i++) {
        values.push({ fileStorageId: data.employeeList[i].employeeFileId5 });
      }
    }
    if (data.partnerList != "") {
      for (let i = 0; i < data.partnerList.length; i++) {
        values.push({ fileStorageId: data.partnerList[i].partnerFileId });
      }
    }
    setfileArrayList(values);
    getImageList(values, data.employeeList, data.partnerList);

    setformLoading(false);
  };
  const [imageList, setimageList] = useState([]);

  const getImageList = async (imgList, emp, partner) => {
    await axios
      .post(BaseUrl + "getFileDetailList", imgList)
      .then((res) => {
        // console.log("sdjsinscisnicussi", res.data);
        setimageList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sumbitForm = (values) => {
    console.log("submitObject", `${JSON.stringify(values, null, 2)}`);
    axios
      .post(BaseUrl + "createCompany", values)
      .then((res) => {
        console.log(res.data);
        if (res.data.errCode == 200) {
          Swal.fire("Company Details Saved");
        }
        navigate("/create-company-new");
      })
      .catch((error) => {});
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Company Details
        </Header>
      </Grid.Row>

      {formLoading === false ? (
        <>
          <Grid.Row>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="ownerOrPartner"
                    label="Owner / Partner Name"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="companyContact"
                    label="Contact"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="eMailId"
                    label="Email"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="companyName"
                    label="Company Name"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="licenseNumber"
                    label="License Number"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="licenseExp"
                    label="License Expiry"
                    type="date"
                    component={renderTextField}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>
          <Grid.Row>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    name="activities"
                    label="Activities"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="establismentCardNo"
                    label="Establismnent Card Number"
                    type="text"
                    component={renderTextField}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name="establismentCardExp"
                    label="EstablismnentCard Expiry"
                    type="date"
                    component={renderTextField}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Row>

          <Grid.Row>
            <div className="label123">Additional Remarks</div>
            <Field
              key="field"
              name="additionalRemarks"
              label="Additional Remarks"
              id="inputEditorText"
              disabled={false}
              component={NoteEditorField}
            />
          </Grid.Row>
          <Divider section />
          <Label>
            <h3>Company Document List</h3>
          </Label>
          <FieldArray
            name="filesList"
            component={FileArrList}
            imageList={fileArrImageList}
            companyData={companyData}
            //imageList={imageList}
          />
          <Divider section />
          {/* <Label>
        <h3>Partner Document List</h3>
      </Label>
      <FieldArray
        name="partnerList"
        component={PartnerArrList}
        imageList={imageList}
        companyData={companyData}
      />
      <Divider section /> */}
          {/* <Label>
        <h3>Employee Document List</h3>
      </Label>
      <FieldArray
        name="employeeList"
        component={EmployeeArrList}
        imageList={imageList}
        companyData={companyData}
      />
      <br />
      <br /> */}
          <Button
            type="submit"
            floated="right"
            positive
            disabled={submitting}
            onClick={handleSubmit((values) =>
              sumbitForm({
                ...values,
              })
            )}
          >
            Save
          </Button>
          <Button
            floated="right"
            negative
            disabled={pristine || submitting}
            onClick={reset}
          >
            Cancel
          </Button>
          <br />
          <br />
        </>
      ) : (
        <div>
          <h2>Loading</h2>
        </div>
      )}
    </div>
  );
};

export default reduxForm({
  form: "UpdateCompanyForm",
})(UpdateCompanyForm);
